import ExhibitorEditText from './ExhibitorEditText';

const ExhibitorEditBrief = () => {
    return (
        <ExhibitorEditText fname='brief' subtitle='exhibitoredit.brief_hint' limit={150} />
	);
};

export default ExhibitorEditBrief;
